
import { Component, Input, OnInit } from '@angular/core';
import { BudgetAccountLineDTO, BudgetDTO, LotBudgetAccountLineDTO, LotBudgetDTO, ProcurementProjectDTO, ProcurementProjectLotDTO } from '../../api/plyca-dtos-v2';
import { BaseComponent } from '../../components/common/baseComponent/base.component';

/**
 * Clase auxiliar para tabla de 'Distribución anualidades/financiación'.
 */
class DistributionLine {

  lot: ProcurementProjectLotDTO;
  accountLine: LotBudgetAccountLineDTO;
  summatoryLine = false;
  totalLine = false;

  constructor(lot: ProcurementProjectLotDTO, accountLine: LotBudgetAccountLineDTO) {
    this.lot = lot;
    this.accountLine = accountLine;
  }
}

@Component({
  selector: 'plyca-projectBudgetSummaryAM',
  templateUrl: 'procurementProjectBudgetSummaryAM.template.html'
})
export class ProcurementProjectBudgetSummaryAMComponent extends BaseComponent implements OnInit {

  @Input()
  project: ProcurementProjectDTO;

  // propiedades tabla financiacion
  public financeLines: {
    data?: Array<BudgetAccountLineDTO>;
  };
  public financeColHeaders: Array<string>;

  // propiedades tabla presupuesto por lotes
  public budgetLines: {
    data?: Array<ProcurementProjectLotDTO>;
    totalestimatedAmountSum?: number;
  };
  public budgetColHeaders: Array<string>;

  // propiedades tabla distribución anualidades/financiación
  public distributionLines: Array<DistributionLine>;
  // totales por agrupacion en un Map con clave 'lotNumber'
  // public distributionLinesTotal: Map<number, number>;
  public distributionColHeaders: Array<string>;



  constructor() {
    super();
    this.financeColHeaders = [
      'Orgánica',
      'Programa',
      'Económica'
    ];
    this.budgetColHeaders = [
      'Lote',
      'Valor estimado'
    ];
    this.distributionColHeaders = [
      'Lote',
      'Anualidad',
      'Orgánica',
      'Programa',
      'Económica'
    ]
    // inicializar objetos de tablas
    this.financeLines = {
      data: []
    };
    this.budgetLines = {
      data: []
    };
    this.distributionLines = [];
  }

  ngOnInit(): void {
    if (this.project) {
      this.initFinanceTable();
      this.initBudgetTable();
      this.initDistributionTable();
    }
  }

  private initFinanceTable(): void {
    if (this.project.budget?.budgetAccounLine) {
      if (this.project.budget.budgetAccounLine.length > 0) {
        let sumBudget = new BudgetAccountLineDTO();
        let budget = new BudgetDTO();
        sumBudget.budget = budget;
        // el sort se hace con el operador [...array].sort para no afectar al orden de la lista original
        let orderedBudget = [...this.project.budget.budgetAccounLine]
          .sort((budget1, budget2) => (budget1.year || Number.MAX_VALUE) - (budget2.year || Number.MAX_VALUE));
        this.financeLines.data = [].concat(orderedBudget);
      }
    }
  }

  private initBudgetTable(): void {
    if (this.project.breakdownLot?.lots) {
      let totalestimatedAmountSum = 0;
      // el sort se hace con el operador [...array].sort para no afectar al orden de la lista original
      let orderedLots = [...this.project.breakdownLot.lots].sort((lot1, lot2) => (lot1.lotNumber || 0) - (lot2.lotNumber || 0));
      orderedLots.forEach((lot: ProcurementProjectLotDTO) => {
        totalestimatedAmountSum += lot.budget?.estimatedAmount || 0;
      });
      if (orderedLots.length > 0) {
        let sumLot = new ProcurementProjectLotDTO();
        let lotBudget = new LotBudgetDTO();
        lotBudget.estimatedAmount = totalestimatedAmountSum;
        sumLot.budget = lotBudget
        this.budgetLines.data = [].concat(orderedLots);
        this.budgetLines.data.push(sumLot);
      }
    }
  }

  private initDistributionTable(): void {
    if (this.project.breakdownLot?.lots) {
      // el sort se hace con el operador [...array].sort para no afectar al orden de la lista original
      let orderedLots = [...this.project.breakdownLot.lots].sort((lot1, lot2) => (lot1.lotNumber || 0) - (lot2.lotNumber || 0));
      this.distributionLines = [];
      orderedLots.forEach((lot: ProcurementProjectLotDTO) => {
        if (lot.budget?.lotBudgetAccountLine) {
          lot.budget?.lotBudgetAccountLine?.forEach((budgetAccountLine: LotBudgetAccountLineDTO) => {
            this.distributionLines.push(new DistributionLine(lot, budgetAccountLine));
          });
        }
      }
      );
    }
  }
}
